<div class="p-3">
  <div class="flex justify-between">
    <h2 class="header-text">Units per visit average:</h2>
    <thera-dropdown class="option-values w-[40%]" [defaultSelection]="selectedOption" (optionSelected)="onValueChange($event)"
      [options]="datesOptions"></thera-dropdown>
  </div>
  <div class="flex gg-total">
    <span>{{displayValueForUnitsPerVisist}}</span>
    <label>units per visit</label>
  </div>
  <div>
    <div class="grey-box mb-2">
      Revenue: <span class="ml-2">Not Yet Available</span>
    </div>
    <div class="grey-box">
      MMR Threshold: <span class="ml-2">Not Yet Available</span>
    </div>
  </div>
</div>